import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const razorpayOrderApi = createAsyncThunk(
  "razorpayOrder",
  async (payload) => {
    // const response = await axiosInstance.post("/Razorpay", payload);
    const response = await axiosInstance.post("/cashfree", payload);
    return response.data;
  }
);

const initialState = {
  data: [],
  errors: [],
  loading: false,
};

const razorpayOrderSlice = createSlice({
  name: "razorpayOrder",
  initialState,
  reducers: {
    resetState: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(razorpayOrderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(razorpayOrderApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(razorpayOrderApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export const { resetState } = razorpayOrderSlice.actions;

export default razorpayOrderSlice.reducer;
